module.exports = __webpack_public_path__ + "static/media/DMSans-Regular.ee47ebaf.ttf";